/* Spanish catalog mirroring locale-closing-purchases-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'route.arsavslutning-kjop': 'Compras y recibos',
  'clo.purchases.title': 'Compras y recibos',
  'clo.purchases.year': 'Ejercicio fiscal {{year}}',
  'clo.purchases.subtitle': 'Revisa las compras y los recibos del ejercicio fiscal {{year}}.',
  'clo.purchases.pending': '{{count}} compras o recibos requieren atención antes de que la comprobación de compras de {{year}} esté lista.',
  'clo.purchases.ready': 'No se encontraron compras sin procesar ni documentos de compra pendientes para {{year}}.',
  'clo.purchases.unsupported': 'La comprobación de compras no está disponible para este país, marco contable o año.',
  'clo.purchases.purchaseIssues': 'Compras que requieren atención',
  'clo.purchases.missingTitle': 'Movimientos sin documentación ({{count}})',
  'clo.purchases.missingSummary': 'Añade el documento justificativo de cada movimiento.',
  'clo.purchases.reviewMissing': 'Ver y añadir documentos',
  'clo.purchases.documentsModalTitle': 'Documentación pendiente',
  'clo.purchases.missingHelp': 'Suelta un documento en la fila correcta o súbelo.',
  'clo.purchases.missingDateAction': 'Falta una fecha válida: abre el movimiento para elegir su año',
  'clo.purchases.upload': 'Subir documento',
  'clo.purchases.uploading': 'Subiendo …',
  'clo.purchases.uploaded': 'El documento se añadió.',
  'clo.purchases.uploadLater': 'Subir documentos más tarde',
  'clo.purchases.uploadError': 'No se pudo subir el documento.',
  'clo.purchases.noMissingDocumentation': 'Todos los movimientos tienen documentación.',
  'clo.purchases.deferredHelp': 'Los documentos se subirán más tarde. Puedes continuar la revisión, pero debes añadirlos antes de cerrar el ejercicio.',
  'clo.purchases.inboxSideHelp': 'Estos documentos aún no se han contabilizado.',
  'clo.purchases.inboxInteractionHint': 'Abre un documento para revisarlo.',
  'clo.purchases.continueWithoutInbox': 'Continuar sin procesar',
  'clo.purchases.continueConfirmTitle': '¿No es relevante para este cierre del ejercicio?',
  'clo.purchases.continueConfirmText': 'Confirma que los {{count}} documentos sin procesar no son relevantes para la revisión de compras de {{year}}. Siguen en la bandeja de entrada, pero no bloquearán este cierre del ejercicio.',
  'clo.purchases.inboxExcluded': 'Los documentos se evaluaron como no relevantes para este cierre del ejercicio.',
  'clo.purchases.excludeError': 'No se pudo guardar la evaluación.',
  'clo.purchases.noPurchaseIssues': 'No hay problemas pendientes en las compras registradas.',
  'clo.purchases.missingDocumentation': 'Documentación pendiente',
  'clo.purchases.lostDocumentation': 'Documento declarado perdido. La desviación queda registrada, pero la compra sigue necesitando documentación.',
  'clo.purchases.draft': 'El borrador de compra necesita procesarse',
  'clo.purchases.undated': 'Falta una fecha válida. Establece a qué año pertenece el asiento.',
  'clo.purchases.unknownDate': 'Falta una fecha válida',
  'clo.purchases.inboxTitle': 'Recibos sin procesar ({{count}})',
  'clo.purchases.inboxScope': 'Procesa los documentos que pertenecen a {{year}}, o continúa si no son relevantes para este cierre del ejercicio.',
  'clo.purchases.scopeHelp': 'Una factura de proveedor pendiente de pago puede estar totalmente contabilizada. Los pagos, la conciliación del IVA y el corte de ejercicio se comprueban en pasos aparte. Listo aquí significa que las compras registradas y la bandeja de entrada han superado esta comprobación.',
  'clo.purchases.openPurchase': 'Abrir compra',
  'clo.purchases.openInbox': 'Procesar los recibos de la bandeja de entrada',
  'clo.purchases.back': 'Volver a la revisión de compras',
  'clo.purchases.backToClosing': 'Volver al cierre del ejercicio',
  'clo.purchases.loadError': 'No se pudo abrir el espacio de trabajo de compras.',
  'clo.payables.title': 'Cuentas a pagar a proveedores',
  'clo.payables.itemsTitle': 'Partidas abiertas de proveedores a 31 de diciembre de {{year}}',
  'clo.payables.itemsHelp': 'Facturas de proveedores abiertas al cierre del año, incluidas las de años anteriores. Los pagos posteriores se muestran por separado y no cambian el saldo del cierre del año.',
  'clo.payables.supplier': 'Proveedor y documento',
  'clo.payables.date': 'Documento y fecha de vencimiento',
  'clo.payables.openAmount': 'Abierto al cierre del año',
  'clo.payables.followUp': 'Seguimiento',
  'clo.payables.paidAfterAmount': 'Pagado después del cierre del año: {{amount}}',
  'clo.payables.balanceTitle': 'Conciliar con el libro mayor',
  'clo.payables.assessmentTitle': 'Evaluación y aprobación',
  'clo.payables.reviewHelp': 'Revisa las partidas con las casillas de la tabla antes de aprobar.',
  'clo.payables.saveAssessment': 'Guardar evaluación',
  'clo.payables.help': 'El libro mayor y las partidas abiertas de proveedores a 31 de diciembre de {{year}} se comparan automáticamente.',
  'clo.payables.ledger': 'Libro mayor',
  'clo.payables.subledger': 'Libro auxiliar',
  'clo.payables.difference': 'Diferencia',
  'clo.payables.needsReview': 'Requiere revisión ({{count}})',
  'clo.payables.allOpen': 'Todas las partidas abiertas ({{count}})',
  'clo.payables.due': 'Vence el {{date}}',
  'clo.payables.noDueDate': 'Sin fecha de vencimiento',
  'clo.payables.open': 'Abrir movimiento',
  'clo.payables.reviewed': 'Revisado',
  'clo.payables.noRows': 'No hay partidas abiertas en esta vista.',
  'clo.payables.cutOffQuestion': '¿Hay mercancías o servicios recibidos antes del 31 de diciembre de {{year}} que no se hayan registrado?',
  'clo.payables.cutOffHelp': 'Esta es la parte que Plumme no puede determinar solo con los datos registrados.',
  'clo.payables.cutOffNo': 'No, todo está registrado',
  'clo.payables.cutOffYes': 'Sí, falta algo',
  'clo.payables.unrecordedHelp': 'Registra las compras que faltan antes de completar la comprobación.',
  'clo.payables.complete': 'Aprobar revisión',
  'clo.payables.saved': 'Las cuentas a pagar a proveedores se han revisado.',
  'clo.payables.saveError': 'No se pudo guardar la revisión.',
  'clo.payables.reason.reconciled': 'Conciliado',
  'clo.payables.reason.notApplicable': 'No hay cuentas a pagar a proveedores al cierre del año.',
  'clo.payables.reason.unsupported': 'Esta comprobación no está disponible para el país, marco contable o año seleccionado.',
  'clo.payables.reason.stale': 'La base contable cambió. Revisa las partidas de nuevo.',
  'clo.payables.reason.ledgerDifference': 'El libro mayor y el libro auxiliar no coinciden.',
  'clo.payables.reason.missingDocument': 'A una partida abierta de proveedor le falta documentación.',
  'clo.payables.reason.invalidDate': 'Una factura de proveedor no tiene una fecha válida.',
  'clo.payables.reason.basisReviewRequired': 'La base de las cuentas necesita revisión.',
  'clo.payables.reason.cutOffRequired': 'Debe aclararse un hecho.',
  'clo.payables.reason.unrecordedItems': 'Deben registrarse las compras que faltan.',
  'clo.payables.reason.exceptionsRequired': 'Revisa las partidas marcadas.',
  'clo.payables.reason.reviewRequired': 'Debe completarse la comprobación.',
  'clo.payables.issue.ledgerDifference': 'Corrige la diferencia contable antes de completar la comprobación.',
  'clo.payables.issue.missingDocument': 'Añade documentación a las partidas abiertas a las que les falte.',
  'clo.payables.issue.invalidDate': 'Abre la factura del proveedor e introduce la fecha de factura correcta.',
  'clo.payables.issue.basisReviewRequired': 'Plumme no puede calcular una base de cuentas fiable para esta empresa.',
  'clo.payables.flag.old': 'Más de 90 días de antigüedad',
  'clo.payables.flag.overdue': 'Más de 30 días vencida',
  'clo.payables.flag.negative': 'Saldo negativo',
  'clo.payables.flag.duplicate': 'Posible duplicado',
  'clo.payables.flag.currency': 'Moneda extranjera',
  'clo.payables.flag.missingDocument': 'Documentación pendiente',
  'clo.payables.flag.paidAfter': 'Pagado después del cierre del año',
});
